import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { InstallationFeaturesStore } from '@store';
import {
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsStringValueProperty,
  LeakDetectionCommands,
  LeakDetectionProperties,
  SaltLevelProperties,
} from '@vi-iot/client';

import { Observable } from 'rxjs';
import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';

@Component({
  selector: 'app-eco-water',
  templateUrl: './eco-water.component.html',
  styleUrls: ['./eco-water.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EcoWaterComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;
  availableOverlays = FeaturesDetailsOverlayTypeEnum;
  deviceVariant$: Observable<Feature<IsStringValueProperty, never>>;
  saltLevelDays$: Observable<Feature<SaltLevelProperties, never>>;
  leakDetection$: Observable<Feature<LeakDetectionProperties, LeakDetectionCommands>>;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.saltLevelDays$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ecoWaterSaltLevelDays
    );
    this.deviceVariant$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceVariant
    );
    this.leakDetection$ = this.installationFeaturesStore.selectInstallationDeviceFeature<
      LeakDetectionProperties,
      LeakDetectionCommands
    >(FeatureNames.leakDetection);
  }
}
